import React, {
  useCallback,
  useMemo,
  useState,
  useRef,
  useEffect,
} from 'react';
import { StyledDropdown } from './styles';
import { useOnClickOutside } from '../../hooks/useOnClickOutside';
import Skeleton from 'react-loading-skeleton';
import { ReactComponent as CaretDownIcon } from '../../assets/novosicones/Sindico/CaretDown.svg';
import { ReactComponent as SearchIcon } from '../../assets/novosicones/Sindico/search.svg';

const Dropdown = ({
  disableSearchBar,
  placeholderSearchBar,
  itensList = [],
  selectedItem = undefined,
  textNotSelected,
  maxHeightDropdownContent,
  isLoading,
  textEmpty,
  width,
  marginTop,
  marginBottom,
  onSelectItem,
}) => {
  const [searchText, setSearchText] = useState('');
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const node = useRef(null);
  useOnClickOutside(node, () => setIsDropdownOpen(false));

  const toggleIsDropdownOpen = useCallback(
    () => setIsDropdownOpen((prev) => !prev),
    []
  );

  console.log(itensList);

  const textSelect = useMemo(() => {
    const defaultText = 'Selecione:';
    return selectedItem?.nome ?? textNotSelected ?? defaultText;
  }, [selectedItem?.nome, textNotSelected]);

  const filterBySearchText = useCallback(
    ({ nome }) => {
      return nome.toLowerCase().includes(searchText?.toLowerCase());
    },
    [searchText]
  );

  const handleSelectItem = useCallback(
    (ItemList) => {
      if (!onSelectItem) return;

      onSelectItem(ItemList);
      toggleIsDropdownOpen();
    },
    [onSelectItem, toggleIsDropdownOpen]
  );

  useEffect(() => {
    if (itensList.length > 0 && !selectedItem?.nome) {
      handleSelectItem(itensList[0]);
      toggleIsDropdownOpen();
    }
  }, [itensList]);
  return (
    <StyledDropdown
      $marginTop={marginTop}
      $marginBottom={marginBottom}
      $width={width}
      $maxHeight={maxHeightDropdownContent}
      $rotateIconDropdown={isDropdownOpen}
    >
      <div ref={node} className='container-dropdown-search'>
        <div className='selected-item-dropdown-search'>
          <button onClick={toggleIsDropdownOpen}>
            <span>{textSelect}</span> <CaretDownIcon />
          </button>
        </div>

        {isDropdownOpen && (
          <div className='content-dropdown-search'>
            {!disableSearchBar && (
              <div className='search-bar-dropdown-search'>
                <SearchIcon />
                <input
                  disabled={isLoading}
                  placeholder={placeholderSearchBar}
                  value={searchText}
                  onChange={(e) => setSearchText(e.target.value)}
                />
              </div>
            )}

            <div className='items-list-dropdown-search'>
              {!isLoading &&
                itensList?.length > 0 &&
                itensList.filter(filterBySearchText).map((item) => (
                  <button
                    key={item.id}
                    onClick={() => handleSelectItem(item)}
                    className={
                      selectedItem?.id === item.id
                        ? 'selected-item-dropdown-search'
                        : ''
                    }
                  >
                    {item.nome}
                  </button>
                ))}
              {!isLoading && itensList?.length < 1 && (
                <span className='text-empty-dropdown-search'>{textEmpty}</span>
              )}

              {isLoading && (
                <Skeleton
                  height={20}
                  count={3}
                  className='skeleton-drop-down'
                  containerClassName='flex-1'
                />
              )}
            </div>
          </div>
        )}
      </div>
    </StyledDropdown>
  );
};

export default Dropdown;
